import React, { useEffect, useRef, useState } from 'react';
import { Icon } from 'antd';
import { BUSINESS_LOGIC_TAB } from '../translationValues';
import { PurpleTooltip } from './businessLogicTable';
import { minusIcon } from '../../../images/svgIcons';

const getScrolledLeft = el => {
  const left = 110;
  if (el && el.scrollLeft) {
    return left - el.scrollLeft;
  }
  return left;
};

const checkInView = (container, element, partial) => {
  const cLeft = container.scrollLeft;
  const cRight = cLeft + container.clientWidth - 256;
  const eLeft = element.offsetLeft - 126;
  const eRight = eLeft + element.clientWidth;
  const isTotal = eLeft >= cLeft && eRight <= cRight;
  let isPartial;

  if (partial === true) {
    isPartial = (eLeft < cLeft && eRight > cLeft) || (eRight > cRight && eLeft < cRight);
  } else if (typeof partial === 'number') {
    if (eLeft < cLeft && eRight > cLeft) {
      isPartial = ((eRight - cLeft) * 100) / element.clientWidth > partial;
    } else if (eRight > cRight && eLeft < cRight) {
      isPartial = ((cRight - eLeft) * 100) / element.clientWidth > partial;
    }
  }
  return isTotal || isPartial;
};

const TableDraggadbleHead = ({ item, index, t, ruleHintTooltipProps, ...props }) => {
  const {
    tableScrollRef,
    ruleRearrange,
    deleteRule,
    tableHeadData,
    ruleDeleteIndex,
    setRuleDeleteIndex,
  } = props;
  const ref = useRef(null);
  const scrollLeftRef = useRef(110);
  const [, setIsScrolling] = useState();

  useEffect(() => {
    tableScrollRef &&
      tableScrollRef.current.addEventListener('scroll', () => {
        scrollLeftRef.current = getScrolledLeft(tableScrollRef.current);
        setIsScrolling(true);
        setImmediate(() => setIsScrolling(false));
      });
  }, []);

  const isInView =
    tableScrollRef.current && ref.current && checkInView(tableScrollRef.current, ref.current, true);
  const hideRuleDelete = !isInView || tableHeadData.length <= 2 || index !== ruleDeleteIndex;
  const hideSwap = index !== 1;

  return (
    <>
      {index === 0 ? (
        <th>{item}</th>
      ) : (
        <th
          id={`rule-${index}`}
          ref={ref}
          onMouseEnter={() => setRuleDeleteIndex(index)}
          onMouseLeave={() => setRuleDeleteIndex(0)}
        >
          <PurpleTooltip
            title={t(
              BUSINESS_LOGIC_TAB.REMOVE_RULE_TOOLTIP.key,
              BUSINESS_LOGIC_TAB.REMOVE_RULE_TOOLTIP.value,
            )}
          >
            <div
              className="scroll-head"
              style={{ marginLeft: scrollLeftRef.current, display: hideRuleDelete ? 'none' : '' }}
            >
              <Icon onClick={() => deleteRule(index - 1)} component={minusIcon} />
            </div>
          </PurpleTooltip>
          {hideSwap && (
            <span className="swap-icon" onClick={() => ruleRearrange(index - 2, index - 1)}>
              <Icon type="swap" />
            </span>
          )}
          {item}{' '}
          <PurpleTooltip
            overlay={t(
              BUSINESS_LOGIC_TAB.HOW_TO_ADD_RULES.key,
              BUSINESS_LOGIC_TAB.HOW_TO_ADD_RULES.value,
            )}
            {...ruleHintTooltipProps}
          >
            <Icon type="info-circle" />
          </PurpleTooltip>
        </th>
      )}
    </>
  );
};

export const TableHead = ({ tableHeadData = [], flowHints, isNewFlow, t, ...props }) => {
  const { tableScrollRef, ruleRearrange, deleteRule, ruleDeleteIndex, setRuleDeleteIndex } = props;
  const [ruleHintTooltipProps, setRuleHintTooltipProps] = useState({});

  useEffect(() => {
    let timeout;
    if (isNewFlow && flowHints.variableHintDone) {
      setRuleHintTooltipProps({ visible: true });
      timeout = setTimeout(() => {
        setRuleHintTooltipProps({ visible: false });
        setRuleHintTooltipProps({});
      }, 3000);
    }
    return () => clearTimeout(timeout);
  }, [flowHints.variableHintDone]);

  return (
    <thead>
      <tr>
        {tableHeadData.map((item, index) => (
          <TableDraggadbleHead
            item={item}
            index={index}
            t={t}
            ruleDeleteIndex={ruleDeleteIndex}
            ruleRearrange={ruleRearrange}
            deleteRule={deleteRule}
            setRuleDeleteIndex={setRuleDeleteIndex}
            tableScrollRef={tableScrollRef}
            ruleHintTooltipProps={ruleHintTooltipProps}
            tableHeadData={tableHeadData}
          />
        ))}
      </tr>
    </thead>
  );
};
